import type { DpopPublicKey } from './key';

// how a login body tells the server which key to bind the new session to
export function appendDpopPublicKey<T extends object>(
  payload: T,
  publicKey: DpopPublicKey | null | undefined,
): T & { dpopPublicKey?: DpopPublicKey } {
  if (!publicKey) return payload;
  return { ...payload, dpopPublicKey: publicKey };
}
